module.exports = __webpack_public_path__ + "static/img/image1.d096ce49.png";